export class Permissions {
    // Read, Participate, Evaluate, Modify, ModifyInstance
    constructor(permissions = '') {
        this.canRead = false;
        this.canParticipate = false;
        this.canEvaluate = false;
        this.canModify = false;
        this.canModifyInstance = false;

        const permArray = permissions.split(',');

        permArray.forEach(p => {
            p = p.trim().toLowerCase();
            this.canRead = this.canRead || p === 'read';
            this.canParticipate = this.canParticipate || p === 'participate';
            this.canEvaluate = this.canEvaluate || p === 'evaluate';
            this.canModify = this.canModify || p === 'modify';
            this.canModifyInstance = this.canModifyInstance || p === 'modifyinstance';
        });
    }
}
